<template>
  <div class="mb-1">
    <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
      <reward
        v-for="(reward, index) in rewards"
        :key="index"
        class="mb-4"
        :title="reward.title"
        :icon="getIcon(type, reward.title)"
        :metric-title="reward.metricTitle"
        :limits="reward.limits"
        :prices="reward.prices"
        :disabled-limits="disabledLimits"
      >
        <div v-if="period">
          <div v-for="(item, i) in reward.prices" :key="i">
            <strong>{{ item.price }} stakes</strong> / {{ period }}
          </div>
        </div>
      </reward>
    </masonry>
  </div>
</template>

<script>
import Reward from '@/views/Campaign/BountyCampaign/components/Reward.vue';

export default {
  components: {
    Reward
  },

  props: {
    type: {
      type: String,
      default: ''
    },
    disabledLimits: {
      type: Boolean,
      default: false
    },
    period: {
      type: String,
      default: ''
    },
    rewards: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  methods: {
    getIcon(type, task) {
      let icon = this.$config.taskIcons.get(`${type}--${task}`.toLowerCase());
      return icon !== undefined ? icon : 'post';
    }
  }
};
</script>
